export default {
  path: '/wecode/hardware',
  auth: false,
  preload: false,
  key: 'new-solution',
  component: () => import('./index')
};
